import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import config from 'config'
import container from '../../helpers/container'
import {
  ContainerDivs,
  Link,
  FamilyGrid,
} from '../../components'
import Styles from './AssetManagers.css'

@CSSModules(Styles, {allowMultiple:true})
export default class AssetManagers extends Component {
  constructor(props) {
    super(props)
    const allFams = config.formOptions.fundFamilyAll
    const filteredFams = allFams.reduce((arr, el) => {
      if (el.name !== 'All funds') {
        arr.push(el)
      }
      return arr
    }, [])

    this.state = {
      filteredFams,
      title: 'Asset managers',
      description: 'We analyze the mutual funds of major asset managers managers funds to measure their investments in sustainability risk sectors.',
      url: config.domain + config.routes.assetManagers
    }
  }

  render() {
    //
    return (
      <div styleName='page'>
        {
          container.helmet(
            this.state.title,
            this.state.description,
            this.state.url
          )
        }
        <ContainerDivs>
          <h1 styleName='small-page-title'>
            {this.state.title}
          </h1>
          <div styleName='copy'>
            <p>Retirement plans are usually based around funds from major asset managers like Vanguard, BlackRock, and Fidelity. We analyze these managers' funds to measure their investments in sustainability risk sectors. Choose an asset manager below to see how their funds are rated on fossil fuels. We also have data on asset managers for <Link xstrong to="https://deforestationfreefunds.org/families">deforestation</Link>,
              as well as social issues like <Link xstrong to="https://genderequalityfunds.org/families">gender
              equality</Link>, <Link xstrong to="https://gunfreefunds.org/families">civilian firearms</Link>, <Link xstrong to="https://prisonfreefunds.org/families">the prison industrial complex</Link>, <Link xstrong to="https://weaponfreefunds.org/families">arms manufacturers and military contractors</Link>,
              and <Link xstrong to="https://tobaccofreefunds.org/families">tobacco</Link>.</p>
          </div>

          <FamilyGrid />

          <nav>
            {
              this.state.filteredFams.map((el, ix) => {
                return (
                  <Link
                    to={config.links.fff + '/families?q=' + el.name}
                    title={el.name}
                    key={el.name}
                  >
                    <h2 styleName='addtl-fam-link'>
                      { el.name }
                    </h2>
                  </Link>
                )
              })
            }
          </nav>

          <br/>
          <br/>
          <br/>

        </ContainerDivs>
      </div>
    )
  }
}